import { Alert, Button, Center, Container, Image, rem, Stack, Text, Title } from "@mantine/core";
import { IconCircleCheck, IconInfoTriangle } from "@tabler/icons-react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useCustomer } from "shared/graphql/cust";
import { MessageStatus, MessageStatusSchema } from "src/gql/zod";
import { match } from "ts-pattern";
import z from "zod";

const AcknowledgedComponent = () => {
    const { data: customer } = useCustomer();
    const { status } = Route.useSearch();

    return (
        <Center h="100dvh">
            <Container size={420} my={40}>
                <Stack>
                    <Image
                        mx="auto"
                        src={`${import.meta.env.VITE_API_BASE_URL}/customers/${customer.id}/icon`}
                        fallbackSrc="/bryx.svg"
                        radius="md"
                        style={{ maxWidth: rem(100), maxHeight: rem(100) }}
                        alt="customer logo"
                    />
                    <div style={{ textAlign: "center" }}>
                        <Title order={5}>{customer.name}</Title>
                        <Title order={6} c="dimmed">
                            Mass Notification System
                        </Title>
                    </div>
                    {match(status)
                        .with(MessageStatus.Expired, () => (
                            <Alert variant="light" title="Message Expired" color="yellow" icon={<IconInfoTriangle size={20} />}>
                                <Text size="sm">This message is no longer accepting acknowledgements.</Text>
                            </Alert>
                        ))
                        .with(MessageStatus.Published, () => (
                            <Alert variant="light" title="Message Acknowledged" color="green" icon={<IconCircleCheck size={20} />}>
                                <Text size="sm">Your acknowledgement has been recorded, you may close this window or login.</Text>
                            </Alert>
                        ))
                        .otherwise(() => (
                            <Alert variant="light" color="red" title="Acknowledgment Failed">
                                <Text size="sm" ta="center" style={{ textWrap: "balance" }}>
                                    Your acknowledgment was not recorded.
                                </Text>
                            </Alert>
                        ))}

                    <Button component={Link} w="100%" to="/">
                        Go Home
                    </Button>
                </Stack>
            </Container>
        </Center>
    );
};

/** @public */
export const Route = createFileRoute("/acknowledged")({
    component: AcknowledgedComponent,
    validateSearch: z.object({ status: MessageStatusSchema.default(MessageStatus.Published) }),
});
